
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-stop-hand"}},[_c('rect',{attrs:{"width":"12","height":"15","fill":"#727998"}})])]),_c('g',{attrs:{"clip-path":"url(#clip-path-stop-hand)"}},[_c('path',{attrs:{"d":"M11.77 6.726a1.727 1.727 0 00-2.27-.9V2.637A1.762 1.762 0 007.7.96a2.292 2.292 0 00-.379.054 1.721 1.721 0 00-3.14 0A2.319 2.319 0 003.8.96h-.035A1.764 1.764 0 002 2.723V2.9a1.438 1.438 0 00-.216-.022 1.693 1.693 0 00-1.232.462A1.78 1.78 0 000 4.638v5.215a5.034 5.034 0 005.031 5.031h1.287a4.124 4.124 0 002.889-1.19l1.1-1.1A4.035 4.035 0 0011.5 9.7V8.533a1.747 1.747 0 00.27-1.807m-1.231 1.033a.915.915 0 00-.277.65v1.276a2.839 2.839 0 01-.833 2.015l-1.1 1.1a2.862 2.862 0 01-2.014.836H5.041a3.844 3.844 0 01-3.78-3.579c0-.03 0-.054-.008-.076a.936.936 0 01-.012-.141V4.611a.5.5 0 01.174-.374.466.466 0 01.349-.137.528.528 0 01.386.174.572.572 0 01.138.312v2.875a.471.471 0 00.47.47.482.482 0 00.48-.474V2.721a.545.545 0 01.521-.521.524.524 0 01.517.5v.073l.055 3.746a.47.47 0 00.468.463.482.482 0 00.481-.481l-.053-4.712a.514.514 0 01.5-.529.559.559 0 01.542.547v5.182a.471.471 0 00.471.47.48.48 0 00.48-.472V2.71a.525.525 0 01.5-.508.558.558 0 01.54.55v6.159l-.2.041a3.3 3.3 0 00-.9.327.926.926 0 00-.114.073l-.154.1c-.045.028-.092.055-.135.088a2.935 2.935 0 00-.359.319.465.465 0 00-.007.668.48.48 0 00.672 0 2.365 2.365 0 01.723-.49l.057-.028a2.374 2.374 0 01.9-.178.482.482 0 00.482-.481V8.332a1.837 1.837 0 01.556-1.286.508.508 0 01.351-.159.575.575 0 01.374.136.516.516 0 01.033.736","fill":"#727998"}})])])
          )
        }
      }
    